/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// In test-component.js
(function() {
	"use strict";
	
	
	// Add a clear visual indicator that the script is running
	document.addEventListener('DOMContentLoaded', function() {
	  const components = document.querySelectorAll('.test-component');
	  if (components.length > 0) {
		components.forEach(component => {
		  // Add a data attribute or class to show the JS is working
		  component.setAttribute('data-js-loaded', 'true');
		  // You could also add a visual indicator
		  const indicator = document.createElement('div');
		  indicator.textContent = 'JS Loaded ✓';
		  indicator.style.backgroundColor = 'green';
		  indicator.style.padding = '5px';
		  indicator.style.position = 'absolute';
		  indicator.style.top = '0';
		  indicator.style.right = '0';
		  component.style.position = 'relative';
		  component.appendChild(indicator);
		});
	  }
	});
})();